import { createLightTheme } from '@fluentui/react-components';

const legoBrandPalette = {
  10: '#041525',
  20: '#08213b',
  30: '#0b2e52',
  40: '#113c69',
  50: '#164b81',
  60: '#1b5b99',
  70: '#206cb1',
  80: '#257dca',
  90: '#2b8fe3',
  100: '#52a3ea',
  110: '#74b5ef',
  120: '#93c7f4',
  130: '#b0d9f8',
  140: '#cce9fb',
  150: '#e7f4fd',
  160: '#f5fbff',
};

export const legoTheme = {
  ...createLightTheme(legoBrandPalette),
  colorNeutralBackground1: '#f6f8fb',
  colorNeutralBackground2: '#ffffff',
  colorNeutralBackground3: '#f0f3f8',
  colorNeutralStroke1: '#d6dbe5',
  colorNeutralStroke2: '#e4e8ef',
};

export const sectionAccentMap = {
  home: '#1a3457',
  polaris: '#1659c2',

  swagger: '#b14616',
  admin: '#5f45a8',
};

export function resolveSectionAccent(pageId) {
  if (!pageId) return sectionAccentMap.home;
  const section = pageId.split('/')[0];
  return sectionAccentMap[section] || sectionAccentMap.home;
}
